import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { IZone } from '../../models';
import { usePublicZone } from '../zones/zones.hook';
import {
  CodeLastService,
  FeedbackDialog,
  FeedbackSuccessDialog,
  ZoneFeedback,
  ZoneRating,
} from '../../components/zone-landing-page';

export const CodePage = () => {
  const { code } = useParams<{ code: string }>();

  const [feedbackDialogVisible, setFeedbackDialogVisible] = React.useState(false);
  const [feedbackSuccessDialogVisible, setFeedbackSuccessDialogVisible] = React.useState(false);

  let loading_selectedZone = true;
  let selectedZone: IZone | null = null;
  if (code) {
    [loading_selectedZone, selectedZone] = usePublicZone({ code });
  }

  const styles = {
    container: {
      display: 'flex',
      padding: 2,
    },
    feedbackContainer: {
      boxShadow: '0 0 8px rgba(0,0,0, 0.15)',
      borderRadius: 1,
      margin: 2,
      padding: 4,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  };

  return (
    <Box>
      {!loading_selectedZone && selectedZone && (
        <>
          <Box sx={styles.container}>
            <CodeLastService zone={selectedZone} />
          </Box>

          <Box sx={styles.feedbackContainer}>
            <ZoneRating zone={selectedZone} />
            <Box sx={{ my: 1 }} />
            <ZoneFeedback handleRequestService={() => setFeedbackDialogVisible(true)} />

            <FeedbackDialog
              zone={selectedZone}
              visible={feedbackDialogVisible}
              setVisible={setFeedbackDialogVisible}
              onSuccess={() => setFeedbackSuccessDialogVisible(true)}
            />

            <FeedbackSuccessDialog
              visible={feedbackSuccessDialogVisible}
              setVisible={setFeedbackSuccessDialogVisible}
            />
          </Box>
        </>
      )}
    </Box>
  );
};
